import notification from 'antd/lib/notification';
import message from 'antd/lib/message';
import { JointContent } from 'antd/lib/message/interface';

const MIN_NOTIFICATION_WIDTH = 368; // Default width of antd notification
const MAX_NOTIFICATION_WIDTH = 600;
const AVERAGE_CHAR_WIDTH = 10;
const PADDING = 8;

// Global config
message.config({
    duration: 8,
});

export const globalMessage = {
    ...message,
    error: (content: JointContent, onClose?: VoidFunction) => {
        // TODO: RUN-13996 - Investigate way to use CSS instead of manually calculating notification width
        const notificationWidth = estimateNotificationWidth(content?.toString() ?? '');
        notification.error({
            message: 'Error',
            description: content,
            placement: 'top',
            duration: 0,
            onClose: onClose,
            style: {
                width: notificationWidth + 'px',
            },
        });
    },
};

const estimateNotificationWidth = (
    content: string,
    averageCharWidth: number = AVERAGE_CHAR_WIDTH,
    padding: number = PADDING,
    min: number = MIN_NOTIFICATION_WIDTH,
    max: number = MAX_NOTIFICATION_WIDTH,
): number => {
    const contentWidth = content.length * averageCharWidth;
    const paddedContent = contentWidth + padding * 2;

    return Math.min(Math.max(paddedContent, min), max);
};
